import { Bug } from "lucide-react";
import { Carte, COL, Indisponible, Vide, dateFr, isErreur } from "./shared";

const GRAVITE = { faible: "faible", moyen: "moyenne", severe: "sévère" };

function Titre({ children }) {
  return <div className="text-sm font-semibold mb-1 pt-2" style={{ color: COL.text }}>{children}</div>;
}

export default function SanteCard({ data }) {
  return (
    <Carte titre="Santé des cultures" numero="7" icon={Bug} testId="fiche-sante">
      {isErreur(data) ? <Indisponible /> : (
        <>
          <Titre>Risques élevés du jour (Vigie)</Titre>
          {!data.vigie ? (
            <p className="text-sm" style={{ color: COL.amber }}>Pas encore calculés aujourd'hui : ouvrez la Vigie du carnet.</p>
          ) : data.vigie.risques.length ? data.vigie.risques.map((r) => (
            <div key={r.nom} className="flex justify-between py-1 text-sm">
              <span>{r.nom}</span><span className="font-semibold" style={{ color: "#E07A5F" }}>{r.niveau}</span>
            </div>
          )) : <Vide>Aucun risque élevé aujourd'hui.</Vide>}

          <Titre>Signalements en cours sur la parcelle</Titre>
          {data.signalements_actifs.length ? data.signalements_actifs.map((s, i) => (
            <div key={i} className="py-1 text-sm">
              <div className="flex justify-between gap-2">
                <span className="font-medium">{s.nom}</span>
                <span className="text-xs text-gray-500 shrink-0">{dateFr(s.date)}</span>
              </div>
              <div className="text-xs text-gray-500">
                {[s.categorie, s.gravite && `gravité ${GRAVITE[s.gravite] || s.gravite}`, s.ilot_nom].filter(Boolean).join(" · ")}
              </div>
            </div>
          )) : <Vide>Aucun.</Vide>}

          <Titre>Signalés à moins de 5 km (60 derniers jours)</Titre>
          {data.signalements_proches.length ? data.signalements_proches.map((s, i) => (
            <div key={i} className="flex justify-between gap-2 py-1 text-sm">
              <span>{s.nom}{s.categorie ? <span className="text-xs text-gray-500"> · {s.categorie}</span> : null}</span>
              <span className="text-xs text-gray-500 shrink-0">{s.nombre} × à {s.distance_km} km</span>
            </div>
          )) : <Vide>Aucun.</Vide>}
        </>
      )}
    </Carte>
  );
}
